import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
const CircularProgressWithLabel = ({ value, size = 50, thickness = 4, color = 'primary', data }) => {
    return (
        <Box
            position="relative"
            display="inline-flex"
            sx={{
                '&:hover .hover-text': {
                    display: 'block',
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    border: '4px solid lightGray',
                    boxSizing: 'border-box',
                    mt: 0.5,
                }}
            />
            <CircularProgress
                variant="determinate"
                value={value}
                size={size}
                thickness={thickness}
                sx={{
                    color: 'green',
                    '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                    },
                    mt: 0.5,
                }}
            />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography
                    variant="caption"
                    component="div"
                    color="green"
                    paddingTop="4px"
                    paddingLeft="1px"
                    fontSize="11px"
                >
                    {`${Math.round(value)}%`}
                </Typography>
            </Box>
            <Box
                className="hover-text"
                sx={{
                    display: 'none',
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'white',
                    color: 'black',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    fontSize: '12px',
                    zIndex: 1,
                    whiteSpace: 'nowrap',
                }}
            >
                {Object.keys(data)
                    .slice(1)
                    .some((key) => !data[key].isCompleted) && (
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                            You need to complete these steps
                        </span>
                    )}

                {Object.keys(data).map((key) => (
                    key !== '0' && (
                        <div key={key} style={{ padding: '3px', width: 'auto' }}>
                            {data[key].isCompleted ? (
                                <CheckCircleIcon style={{
                                    color: 'green', fontSize: '12px'
                                }} />
                            ) : (
                                <RadioButtonUncheckedIcon style={{
                                    color: 'red', fontSize: '12px'
                                }} />
                            )}
                            <span style={{ marginLeft: '4px', fontSize: '12px' }}
                            >
                                {data[key].label}</span>
                        </div>
                    )
                ))}

            </Box>
        </Box>
    );
};

export default CircularProgressWithLabel;
